<script lang="ts" setup>
import type { EpcGes } from '@@/shared/property/epc-ges';

const props = defineProps<{
  epcGes: EpcGes
}>();

const showMore = ref(false);

const show = computed(() => {
  const epcExpand = [`available-excessive`, `available`].includes(props.epcGes.epc.status);
  const gesExpand = [`available-excessive`, `available`].includes(props.epcGes.ges.status);
  return {
    epcExpand,
    gesExpand,
    moreLess: epcExpand || gesExpand,
  };
});
</script>

<template>
  <section class="pt-2xl flex flex-col gap-s">
    <IadTitle
      tag="h3"
      :text="$t(`property.epc_ges.title`)"
    />
    <div
      v-if="!showMore"
      class="flex flex-wrap gap-2xl"
    >
      <PropertyDiagnosticRatingEpc :epc-ges />
      <PropertyDiagnosticRatingGes :epc-ges />
    </div>

    <div
      v-if="showMore"
      class="grid md:grid-cols-2 grid-col-2 gap-x-2xl gap-y-l"
    >
      <PropertyDiagnosticExpandEpc :epc-ges />
      <PropertyDiagnosticExpandGes :epc-ges />
    </div>

    <IadLinkMoreLess
      v-if="show.moreLess"
      v-model="showMore"
      class="pt-2xs"
    />
  </section>
</template>
